import react, {useState, useEffect, createContext} from 'react';
import RouterApp from './RouterApp';
// import { Navbar, TopMenu, Header } from './components/navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import WaitingModal  from './components/modal/ModalWaiting';
import { useSelector, useDispatch } from 'react-redux';
import { showLogin, showSignup, showPasswordRecovery, setLanguage } from './store/slices/configSlice';
import {Login} from './pages/login';
import Signup from './pages/signup/signup';
import PasswordRecovery from './pages/passwordRecovery/PasswordRecovery';

import { Box, CssBaseline, Typography } from '@mui/material';

import {Header} from './components/navbar';
import ScrollToTop from './components/util/ScrollToTop';


import {store} from './store'
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next'


export default function App() {
    return(
        <>  
            <Router>
                <RouterApp />
            </Router>
        </>
    )
}
 